import type { ProjectListResponsePageAllOfThreeContentItemAuthContext } from './projectListResponsePageAllOfThreeContentItemAuthContext';
import type { ProjectListResponsePageAllOfThreeContentItemBasicInfo } from './projectListResponsePageAllOfThreeContentItemBasicInfo';
import type { ProjectListResponsePageAllOfThreeContentItemFileInfo } from './projectListResponsePageAllOfThreeContentItemFileInfo';
import type { ProjectListResponsePageAllOfThreeContentItemMetaInfo } from './projectListResponsePageAllOfThreeContentItemMetaInfo';
import type { ProjectListResponsePageAllOfThreeContentItemStatsInfo } from './projectListResponsePageAllOfThreeContentItemStatsInfo';
import type { ProjectListResponsePageAllOfThreeContentItemUserInfo } from './projectListResponsePageAllOfThreeContentItemUserInfo';
import type { ProjectListResponsePageAllOfThreeContentItemUserInteraction } from './projectListResponsePageAllOfThreeContentItemUserInteraction';

/**
 * 구조화된 단일 프로젝트 응답 데이터
 */
export type ProjectListResponsePageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  authContext?: ProjectListResponsePageAllOfThreeContentItemAuthContext;
  /** 프로젝트 기본 정보 */
  basicInfo?: ProjectListResponsePageAllOfThreeContentItemBasicInfo;
  /** 프로젝트 파일 정보 */
  fileInfo?: ProjectListResponsePageAllOfThreeContentItemFileInfo;
  /** 프로젝트 메타 정보 */
  metaInfo?: ProjectListResponsePageAllOfThreeContentItemMetaInfo;
  /** 프로젝트 통계 정보 */
  statsInfo?: ProjectListResponsePageAllOfThreeContentItemStatsInfo;
  /** 간략한 사용자 정보 */
  userInfo?: ProjectListResponsePageAllOfThreeContentItemUserInfo;
  /** 현재 사용자와 프로젝트 간의 상호작용 정보 */
  userInteraction?: ProjectListResponsePageAllOfThreeContentItemUserInteraction;
};
